import {createContext, useContext} from 'react';
import {Interpreter, State} from 'xstate';
import {Actor} from 'xstate/lib/Actor';

export const CurrentServiceContext = createContext<Interpreter<unknown> | undefined>(undefined);
export const CurrentStateContext = createContext<State<unknown> | undefined>(undefined);
export const PlayerServiceContext = createContext<Actor | undefined>(undefined);

export const useCurrentService = () => {
  const service = useContext(CurrentServiceContext);
  if (!service) {
    throw new Error('No service provided in context');
  }
  return service;
};
export const useCurrentState = () => {
  const state = useContext(CurrentStateContext);
  if (!state) {
    throw new Error('No state provided in context');
  }
  return state;
};

export const usePlayerService = () => {
  const state = useContext(PlayerServiceContext);
  if (!state) {
    throw new Error('No player service provided in context');
  }
  return state;
};
